import { Button } from '@/components/ui/button'
import { cn, getValue } from '@/lib/utils'
import { TArticle } from '@/types/blog'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  item: TArticle
  isMonthNews?: boolean
}

export const NewsItem = ({ item, isMonthNews }: Props) => {
  const t = useTranslations('landing_coolmate_101_page.news')
  const url = item?.link || `/post/${item?.seo_alias}`

  return (
    <div
      className={cn(
        'flex h-full flex-col overflow-hidden rounded-xl bg-[#ebebeb80]',
        isMonthNews &&
          'h-[224px] flex-row rounded-lg bg-light lg:h-auto lg:rounded-xl'
      )}
    >
      <Link
        target='_blank'
        rel='noreferrer noopener'
        href={url}
        className={cn(
          'block shrink-0',
          isMonthNews && 'aspect-[195/275] h-full lg:h-[275px] lg:w-[195px]'
        )}
      >
        <Image
          src={item?.images?.[0] ?? ''}
          width={isMonthNews ? 195 : 270}
          height={isMonthNews ? 275 : 285}
          alt={item.title}
          className={cn(
            'object-cover',
            isMonthNews ? 'size-full' : 'h-[200px] w-full lg:h-[285px]'
          )}
        />
      </Link>
      <div className='min-w-0 flex-1 px-5 py-4'>
        <p className='text-xs font-semibold text-neutral-600'>
          {getValue(item, 'blogs.0.title', '')}
        </p>

        <Link
          target='_blank'
          rel='noreferrer noopener'
          href={url}
          className={cn(
            'my-4 line-clamp-2 text-base font-medium leading-6 text-light hover:underline lg:text-lg lg:leading-7',
            isMonthNews &&
              'my-2 line-clamp-3 text-neutral-900 lg:my-4 lg:line-clamp-1'
          )}
        >
          {item.title}
        </Link>

        <p
          className={cn(
            'line-clamp-4 text-sm leading-5 text-light',
            isMonthNews && 'line-clamp-2 text-neutral-900'
          )}
        >
          {item?.excerpt}
        </p>

        {isMonthNews ? (
          <Button
            asChild
            size='small'
            className='mt-2 bg-warning-400 text-xs text-neutral-900 hover:bg-warning-500 active:bg-warning-500 lg:mt-4'
          >
            <Link
              href={getValue(item, 'file_share.0.url', '')}
              target='_blank'
              rel='noreferrer noopener'
            >
              {t('download_document')}
            </Link>
          </Button>
        ) : (
          <Link
            target='_blank'
            rel='noreferrer noopener'
            href={url}
            className='mt-4 inline-block text-sm font-medium text-warning-400 hover:underline'
          >
            {t('read_more')}
          </Link>
        )}
      </div>
    </div>
  )
}
